import { render, staticRenderFns } from "./ModalStudentHandedData.vue?vue&type=template&id=4a58a44e&scoped=true"
import script from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
export * from "./ModalStudentHandedData.vue?vue&type=script&lang=js"
import style0 from "./ModalStudentHandedData.vue?vue&type=style&index=0&id=4a58a44e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58a44e",
  null
  
)

export default component.exports